export default function LongBeachPage() {
  return (
    <iframe
      src="/longbeach-event.html"
      title="Long Beach Real Estate — Yan Tkach"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
